function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useRefCallback, useRefGetter, useSingleton } from '@bydesign-ui/hooks';
import { useCallback, useEffect } from 'react';
import { formatDate, formatDateArr, parseDateArr } from '@bydesign-ui/utils';
import { MultipleDate, PanelType } from '../../../models/date';
export function useMultipleDate(options) {
  var _options$value = options.value,
      value = _options$value === void 0 ? [] : _options$value,
      format = options.format,
      locale = options.locale,
      onChange = options.onChange,
      onUpdatePanelDate = options.onUpdatePanelDate,
      onSetPanelDate = options.onSetPanelDate,
      panelType = options.panelType,
      parts = options.parts,
      extra = _objectWithoutProperties(options, ["value", "format", "locale", "onChange", "onUpdatePanelDate", "onSetPanelDate", "panelType", "parts"]);

  var root = useSingleton(function () {
    var rd = new MultipleDate(panelType);
    parts.forEach(function (part) {
      rd.createPanel(panelType, part);
    });
    return rd;
  });
  var onChangeCallback = useRefCallback(onChange);
  var onSetPanelDateCallback = useRefCallback(onSetPanelDate);
  var formatGetter = useRefGetter(format == null ? locale.defaultFormat[panelType] : format);
  var dateList = parseDateArr(value, formatGetter(), locale, panelType === PanelType.DATE);
  root.updateOptions(extra);
  root.setMultiplePanelUpdate(onUpdatePanelDate);
  root.updateValue(dateList);
  useEffect(function () {
    var callback = function callback(dateList) {
      onChangeCallback(dateList.map(function (item) {
        return formatDate(item, formatGetter(), locale);
      }));
    };

    var setPanelDateCallback = function setPanelDateCallback(params) {
      onSetPanelDateCallback(root, params);
    };

    root.addListener('value-change', callback);
    root.addListener('set-panel-date', setPanelDateCallback);
    return function () {
      root.removeListener('value-change', callback);
      root.removeListener('set-panel-date', setPanelDateCallback);
    };
  }, []);
  var onSetPresetTrying = useCallback(function (preset) {
    if (!preset.value.length) {
      return;
    }

    var newVal = parseDateArr(preset.value, formatGetter(), locale, panelType === PanelType.DATE);
    root.setPresetTrying(newVal);
  }, []);
  var onCancelPresetTrying = useCallback(function () {
    root.resetPresetTrying();
  }, []);
  var onSetPreset = useCallback(function (preset) {
    var newVal = formatDateArr(preset.value, formatGetter(), locale);
    onChangeCallback(newVal);
  }, []);
  return {
    root: root,
    onSetPresetTrying: onSetPresetTrying,
    onCancelPresetTrying: onCancelPresetTrying,
    onSetPreset: onSetPreset
  };
}